"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileTopnavBox = exports.NavBox = exports.SocialBox = exports.TopnavBox = exports.TopnavLink = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

var _filteredLink = _interopRequireDefault(require("../../../../../filteredLink"));

var TopnavLink = (0, _styledComponents["default"])((0, _filteredLink["default"])(['afterContent'])).withConfig({
  displayName: "Elements__TopnavLink",
  componentId: "y8ofly-0"
})(["display:inline-flex;flex-direction:column;align-items:center;justify-content:space-between;text-decoration:none;&::after{content:\"", "\";height:0;visibility:hidden;overflow:hidden;user-select:none;pointer-events:none;font-weight:bold;@media speech{display:none;}}"], function (props) {
  return props.afterContent;
});
exports.TopnavLink = TopnavLink;
var TopnavBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__TopnavBox",
  componentId: "y8ofly-1"
})(["box-sizing:border-box;padding:0 ", ";height:72px;position:sticky;z-index:5;top:0;background:", ";", ""], function (props) {
  return "".concat(props.padding, "px");
}, function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  var _props$theme;

  return "\n    @media only screen and (max-width: ".concat(props === null || props === void 0 ? void 0 : props.theme.responsivePortfolioDesktop, "px) and (min-width: ").concat(props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.responsiveMedium, "px) {\n      width: ").concat(props === null || props === void 0 ? void 0 : props.width, "px;\n      max-width: ").concat(props === null || props === void 0 ? void 0 : props.width, "px;\n      margin: 0 auto;\n      padding: 0;\n      > div:first-of-type {\n        max-width: unset;\n        width: 100%:\n      }\n    }\n  ");
});
exports.TopnavBox = TopnavBox;
var SocialBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__SocialBox",
  componentId: "y8ofly-2"
})(["flex:1;svg{path{fill:", ";}}"], function (props) {
  return props.theme.portfolioForeground1;
});
exports.SocialBox = SocialBox;
var NavBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__NavBox",
  componentId: "y8ofly-3"
})(["flex:1;"]);
exports.NavBox = NavBox;
var MobileTopnavBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__MobileTopnavBox",
  componentId: "y8ofly-4"
})(["max-width:720px;margin:0 auto;svg{path{fill:", ";}}"], function (props) {
  return props.theme[props.fontColor];
});
exports.MobileTopnavBox = MobileTopnavBox;